import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { FieldArray } from "formik";

const SectionNotes = ({ values, errors, touched, handleChange, handleBlur }) => {
  return (
    <>
      <Typography fontWeight={600} mt={3}>Notes</Typography>

      <FieldArray name="notes">
        {({ push, remove }) => (
          <>
            {(values.notes || []).map((n, i) => (
              <Box key={i} display="flex" gap={1} alignItems="center">
                <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  margin="dense"
                  label={`Note ${i + 1}`}
                  name={`notes[${i}]`}
                  value={n}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.notes?.[i] && Boolean(errors?.notes?.[i])}
                  helperText={touched?.notes?.[i] && errors?.notes?.[i]}
                />

                {(values.notes || []).length > 1 && (
                  <IconButton color="error" onClick={() => remove(i)}>
                    <DeleteIcon />
                  </IconButton>
                )}
              </Box>
            ))}

            <Button onClick={() => push("")}>+ Add Note</Button>
          </>
        )}
      </FieldArray>
    </>
  );
};

export default SectionNotes;
